import React, {useState} from "react";
import PropTypes from "prop-types";
import GenericDialog from "components/ui/dialogs/generic-dialog/GenericDialog";
import {Button, Grid, TextField, Typography, useMediaQuery} from "@material-ui/core";
import * as actions from "../../../../../store";
import {connect} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    fullWidth: {
        width: '75%'
    },
}));

const AggiungiReferenteSegnalazione = (props) => {
    const classes = useStyles();
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [email, setEmail] = useState("");
    const [telefono, setTelefono] = useState("");
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const fullWidthInputs = useMediaQuery('(max-width: 960px)');

    const disableButton = () => {
        return name.length * surname.length * telefono.length * email.length === 0 || !regex.test(String(email.toLowerCase()));
    };

    const handleAddReferente = () => {
        props.addNewReferente(name, surname, email, telefono);
        props.setReferente({
            name: name,
            surname: surname,
            text: name + ' ' + surname,
            telephone: telefono,
            email: email,
            value: email + '%_%' + name + ' ' + surname,
            added: true
        });
        props.handleDialogSuccess();
    }

    const dialogContent = (
        <React.Fragment>
            <Typography variant="body2">
                Il Servizio Clienti contatterà la persona da te indicata per tutte le operazioni relative a questa
                segnalazione Tutti i campi sono
                obbligatori.
            </Typography>
            <Grid container spacing={3} className="mb-8">
                <Grid item xs={12} md={6}>
                    <TextField className={fullWidthInputs ? classes.fullWidth : null}
                               onChange={(event) => setSurname(event.target.value)}
                               value={surname}
                               required
                               id="standard-required-cognome"
                               label="Cognome"/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField className={fullWidthInputs ? classes.fullWidth : null}
                               onChange={(event) => setName(event.target.value)}
                               value={name}
                               required
                               id="standard-required-nome"
                               label="Nome"/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField className={fullWidthInputs ? classes.fullWidth : null}
                               onChange={(event) => setEmail(event.target.value)}
                               value={email}
                               required
                               type={"email"}
                               id="standard-required-email"
                               label="Email"/>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField className={fullWidthInputs ? classes.fullWidth : null}
                               onChange={(event) => setTelefono(event.target.value)}
                               value={telefono}
                               type={"number"}
                               onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E') && evt.preventDefault()}
                               required
                               id="standard-required-telefono"
                               label="Telefono"
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );

    const dialogActions = (
        <React.Fragment>
            <Button onClick={props.handleDialogClose} color="primary">
                <div className="align-center-x px-16">ANNULLA</div>
            </Button>
            <Button onClick={handleAddReferente}
                    disabled={disableButton()}
                    color="primary"
                    variant="contained">
                <div className="align-center-x px-16">AGGIUNGI REFERENTE</div>
            </Button>
        </React.Fragment>
    );

    return (
        <GenericDialog
            dialogWidth="sm"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleDialogCloseButton}
            dialogContent={dialogContent}
            dialogActions={dialogActions}
        >
            <Typography variant={"h6"}>Aggiungi un referente per la segnalazione</Typography>
        </GenericDialog>
    );
};
AggiungiReferenteSegnalazione.propTypes = {
    handleDialogClose: PropTypes.func,
    handleDialogCloseButton: PropTypes.func,
    open: PropTypes.bool,
    handleDialogSuccess: PropTypes.func,
    setReferente: PropTypes.func
};

const mapDispatchToProps = (dispatch) => {
    return {
        addNewReferente: (name, surname, email, telefono) =>
            dispatch(actions.addNewReferente(name, surname, email, telefono))
    };
};

export default connect(null, mapDispatchToProps)(AggiungiReferenteSegnalazione);
